import React, { useEffect, useState } from "react";
import Colors from "../../../../Constants/Colors";
import { useDispatch } from "react-redux";
import CustomPagination from "../../../../Components/CustomPagination/CustomPagination";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../../../Config/Actions/loadingActions";
import { apiCallGetBookedTicketsDetails } from "../../../../Core/Apicall";
import EmptyData from "../../../../Components/EmptyData/EmptyData";
import moment from "moment";
import Icons from "../../../../Constants/Icons";

const BookedTickets = ({ eventId }) => {

  const [eventList, setEventList] = useState([]);
  const [eventListTotalCount, setEventListTotalCount] = useState(0);
  const [pagination, setPagination] = useState(0);
  const [initialPage, setInitialPage] = useState(0);

  const [search, setSearch] = useState("");
  const [bookingStatus, setBookingStatus] =
    useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    onApiCallBookedTickets(0);
  }, [search, bookingStatus]);

  const onApiCallBookedTickets = async (selectedPage = 0) => {

    dispatch(setLoadingTrue());

    const param = {
      eventId: eventId,
      offset: selectedPage * 10,
      limit: 10,
      bookingStatus: bookingStatus,
      search: search,
    };;

    try {

      const res =
        await apiCallGetBookedTicketsDetails(
          param
        );

      setEventList(res?.data || []);
      setEventListTotalCount(res?.pagination?.total || 0);
      setPagination(res?.pagination || 0);
      setInitialPage(selectedPage);

      dispatch(setLoadingFalse());

    } catch (error) {

      dispatch(setLoadingFalse());
    }
  };

  return (
    <div className="achievements">

      <div className="upcoming_list">

        <div className="margin-top-20 achievement-container">

          {/* HEADER */}

          <div className="achievement-header ">

            <div className="achievement-title">

              <div className="astrologerText">
                Booked Tickets
              </div>

            </div>

          </div>

          {/* FILTERS */}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",
              marginTop: "18px",
              marginBottom: "20px",
            }}
          >

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "14px",
              }}
            >

              {/* SEARCH */}

              <div
                style={{
                  position: "relative",
                  width: "260px",
                }}
              >

                <input
                  type="text"
                  placeholder="Search"
                  value={search}
                  onChange={(e) =>
                    setSearch(e.target.value)
                  }
                  style={{
                    width: "100%",
                    height: "44px",
                    background: "#001B44",
                    border: "1px solid #0EA5FF",
                    borderRadius: "10px",
                    padding: "0px 45px 0px 16px",
                    color: "#FFFFFF",
                    fontSize: "14px",
                    fontWeight: "600",
                    outline: "none",
                    boxSizing: "border-box",
                  }}
                />

                <img
                  src={Icons.ic_search}
                  alt="search"
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "18px",
                    height: "18px",
                    objectFit: "contain",
                    opacity: 0.9,
                    cursor: "pointer",
                  }}
                />

              </div>

              {/* STATUS DROPDOWN */}

              <div
                style={{
                  position: "relative",
                  width: "170px",
                }}
              >

                <select
                  value={bookingStatus}
                  onChange={(e) =>
                    setBookingStatus(e.target.value)
                  }
                  style={{
                    width: "100%",
                    height: "44px",
                    background: "#001B44",
                    border: "1px solid #FF2E93",
                    borderRadius: "10px",
                    padding: "0px 42px 0px 16px",
                    color: "#FFFFFF",
                    fontSize: "14px",
                    fontWeight: "600",
                    outline: "none",
                    cursor: "pointer",
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    boxSizing: "border-box",
                  }}
                >

                  <option
                    value=""
                    style={{
                      background: "#001B44",
                      color: "#FFFFFF",
                    }}
                  >
                    By Status
                  </option>

                  <option
                    value="Pending"
                    style={{
                      background: "#001B44",
                      color: "#FFFFFF",
                    }}
                  >
                    Pending
                  </option>

                  <option
                    value="Confirmed"
                    style={{
                      background: "#001B44",
                      color: "#FFFFFF",
                    }}
                  >
                    Confirmed
                  </option>

                  <option
                    value="Cancelled"
                    style={{
                      background: "#001B44",
                      color: "#FFFFFF",
                    }}
                  >
                    Cancelled
                  </option>

                  <option
                    value="Booked"
                    style={{
                      background: "#001B44",
                      color: "#FFFFFF",
                    }}
                  >
                    Booked
                  </option>

                </select>

                {/* CUSTOM ARROW */}

                <div
                  style={{
                    position: "absolute",
                    right: "16px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    color: "#FFFFFF",
                    fontSize: "12px",
                    fontWeight: "700",
                  }}
                >
                  ▼
                </div>

              </div>

            </div>

          </div>


          {/* TABLE */}

          <div className="achievement-content">

            {/* TABLE HEADER */}

            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                padding: "18px 20px",
                background: "rgba(255,255,255,0.05)",
                borderBottom: "1px solid rgba(255,255,255,0.08)",
                borderRadius: "12px 12px 0px 0px",
                boxSizing: "border-box",
              }}
            >

              <div
                className="lastWeekEndDivGreyColor"
                style={{ width: "26%" }}
              >
                User
              </div>

              <div
                className="lastWeekEndDivGreyColor"
                style={{
                  width: "10%",
                  textAlign: "center",
                }}
              >
                Seat
              </div>

              <div
                className="lastWeekEndDivGreyColor"
                style={{
                  width: "8%",
                  textAlign: "center",
                }}
              >
                Qty
              </div>

              <div
                className="lastWeekEndDivGreyColor"
                style={{
                  width: "10%",
                  textAlign: "center",
                }}
              >
                Price
              </div>

              <div
                className="lastWeekEndDivGreyColor"
                style={{
                  width: "12%",
                  textAlign: "center",
                }}
              >
                Amount
              </div>

              <div
                className="lastWeekEndDivGreyColor"
                style={{
                  width: "14%",
                  textAlign: "center",
                }}
              >
                Payment Status
              </div>

              <div
                className="lastWeekEndDivGreyColor"
                style={{
                  width: "14%",
                  textAlign: "center",
                }}
              >
                Booking Status
              </div>

              <div
                className="lastWeekEndDivGreyColor"
                style={{
                  width: "12%",
                  textAlign: "center",
                }}
              >
                Booking Date
              </div>

            </div>

            {/* TABLE BODY */}

            <div className="scrollable-container h-max-350">

              {eventList?.length === 0 ? (

                <EmptyData />

              ) : (

                eventList.map((items, index) => (

                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "16px 20px",
                      borderBottom:
                        "1px solid rgba(255,255,255,0.08)",
                    }}
                  >

                    {/* USER */}

                    <div
                      style={{
                        width: "24%",
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >

                      <img
                        src={
                          items?.userData?.profileImageURL
                        }
                        alt=""
                        style={{
                          width: "42px",
                          height: "42px",
                          borderRadius: "50%",
                          objectFit: "cover",
                          flexShrink: 0,
                        }}
                      />

                      <div
                        style={{
                          overflow: "hidden",
                        }}
                      >

                        <div
                          className="fontSize16WithoutFlex"
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {items?.userData?.name}
                        </div>

                        <div className="user_text">
                          @{items?.userData?.userName}
                        </div>

                      </div>

                    </div>

                    {/* SEAT */}

                    <div
                      style={{
                        width: "10%",
                        textAlign: "center",
                      }}
                      className="fontSize16WithoutFlex"
                    >
                      {items?.bookedSeatsType}
                    </div>

                    {/* QTY */}

                    <div
                      style={{
                        width: "8%",
                        textAlign: "center",
                      }}
                      className="fontSize16WithoutFlex"
                    >
                      {items?.quantity}
                    </div>

                    {/* PRICE */}

                    <div
                      style={{
                        width: "10%",
                        textAlign: "center",
                      }}
                      className="fontSize16WithoutFlex"
                    >
                      ₹ {items?.ticketPrice}
                    </div>

                    {/* AMOUNT */}

                    <div
                      style={{
                        width: "12%",
                        textAlign: "center",
                      }}
                      className="fontSize16WithoutFlex"
                    >
                      ₹ {items?.totalAmount}
                    </div>

                    {/* PAYMENT STATUS */}

                    <div
                      style={{
                        width: "14%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >

                      <button
                        className="button"
                        style={{
                          minWidth: "110px",
                          height: "34px",
                          borderRadius: "30px",
                          border: "none",
                          fontSize: "13px",
                          fontWeight: "600",

                          backgroundColor:
                            items.paymentStatus ===
                              "Success"
                              ? "rgba(46, 204, 113, 0.15)"
                              : items.paymentStatus ===
                                "Pending"
                                ? "rgba(241, 196, 15, 0.15)"
                                : "rgba(231, 76, 60, 0.15)",

                          color:
                            items.paymentStatus ===
                              "Success"
                              ? "#2ECC71"
                              : items.paymentStatus ===
                                "Pending"
                                ? "#856404"
                                : "#E74C3C",
                        }}
                      >
                        {items.paymentStatus}
                      </button>

                    </div>

                    {/* BOOKING STATUS */}

                    <div
                      style={{
                        width: "14%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >

                      <button
                        className="button"
                        style={{
                          minWidth: "110px",
                          height: "34px",
                          borderRadius: "30px",
                          border: "none",
                          fontSize: "13px",
                          fontWeight: "600",

                          backgroundColor:
                            items.bookingStatus ===
                              "Booked"
                              ? "rgba(0, 168, 255, 0.15)"
                              : items.bookingStatus ===
                                "Confirmed"
                                ? "rgba(46, 204, 113, 0.15)"
                                : items.bookingStatus ===
                                  "Pending"
                                  ? "rgba(241, 196, 15, 0.15)"
                                  : "rgba(231, 76, 60, 0.15)",

                          color:
                            items.bookingStatus ===
                              "Booked"
                              ? "#00A8FF"
                              : items.bookingStatus ===
                                "Confirmed"
                                ? "#2ECC71"
                                : items.bookingStatus ===
                                  "Pending"
                                  ? "#856404"
                                  : "#E74C3C",
                        }}
                      >
                        {items.bookingStatus}
                      </button>

                    </div>

                    {/* DATE */}

                    <div
                      style={{
                        width: "12%",
                        textAlign: "center",
                      }}
                      className="fontSize16WithoutFlex"
                    >
                      {moment(
                        items?.createdAt
                      ).format("DD MMM YYYY")}
                    </div>

                  </div>
                ))
              )}

            </div>

          </div>

        </div>

      </div>

      {/* PAGINATION */}


      {
        eventList?.length > 0 && (

          <div className="Custom-Pagination">

            <CustomPagination
              pageCount={

                Math.ceil(pagination?.total / 10)
              }
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              initialPage={initialPage}
              onPageChange={({ selected }) => {
                onApiCallBookedTickets(selected);
              }}
            />

          </div>
        )
      }

    </div>
  );
};

export default BookedTickets;